import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import AdminLayout from './AdminLayout';

const { FiAlertCircle, FiDatabase } = FiIcons;

const Dashboard = () => {
  return (
    <AdminLayout>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-900">Admin Dashboard</h1>
        <p className="text-slate-600 mt-1">Welcome to the property management interface.</p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8 flex items-start gap-4">
        <SafeIcon icon={FiAlertCircle} className="w-6 h-6 text-blue-600 shrink-0 mt-0.5" />
        <div>
          <h3 className="font-bold text-blue-900 mb-1">Testing Environment Active</h3>
          <p className="text-blue-800 text-sm">
            This administrative interface is currently operating in a temporary access mode. 
            All modifications to the property structure will be saved directly to the connected NoCodeBackend instance via the runtime service.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-slate-100 p-2.5 rounded-lg">
              <SafeIcon icon={FiDatabase} className="w-5 h-5 text-slate-700" />
            </div>
            <h2 className="font-bold text-lg text-slate-900">Quick Actions</h2>
          </div>
          <p className="text-slate-600 text-sm mb-6">Manage your boarding house hierarchy including buildings, floors, rooms, and individual bed spaces.</p>
          <a href="#/admin/structure" className="inline-block px-4 py-2 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-slate-800 transition-colors">
            Manage Property Structure
          </a>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;